export interface AvatarProps {
  name: string;
  tone?: 'accent' | 'dark' | 'cream';
  size?: 'sm' | 'md';
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ name, tone = 'cream', size = 'md' }: AvatarProps) {
  const cls = ['tr-avatar', `tr-avatar--${tone}`, size === 'sm' && 'tr-avatar--sm']
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls} aria-hidden title={name}>
      {initials(name)}
    </span>
  );
}
